import React, { Component } from 'react';
import axios from 'axios';
import Slide from 'react-reveal/Slide';
import { env } from '../../../shared/environment/index';
import IconAlif from '../../../components/icon/IconAlif';
import './Login.scss';

class Login extends Component {
  urlPrefix = env.baseUrl;

  constructor() {
    super();

    this.state = {
      email: '',
      password: '',
      errMessage: '',
    };

    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
    this.login = this.login.bind(this);
    this.sendByEnter = this.sendByEnter.bind(this);
  }

  componentDidMount() {
    localStorage.removeItem('salom::admin::token');
    localStorage.removeItem('salom::admin::id');
    localStorage.removeItem('salom::admin::full_name');
    localStorage.removeItem('salom::admin::role');
    axios
      .get(`${this.urlPrefix}logout`)
      .then((response) => {
        console.log('logout error: ', response.data.message);
      })
      .catch(function (err) {
        console.log('err: ', err);
      });
  }

  handleEmailChange(e) {
    var self = this;

    self.setState({
      email: e.target.value,
    });
  }

  handlePasswordChange(e) {
    var self = this;

    self.setState({
      password: e.target.value,
    });
  }

  login() {
    if (this.state.email && this.state.password) {
      axios
        .post(`${this.urlPrefix}login`, {
          email: this.state.email,
          password: this.state.password,
        })
        .then((response) => {
          if (response.data.code == 200) {
            localStorage.setItem('salom::admin::id', response.data.payload.id);
            localStorage.setItem(
              'salom::admin::full_name',
              response.data.payload.full_name
            );
            localStorage.setItem(
              'salom::admin::token',
              response.data.payload.token
            );
            localStorage.setItem(
              'salom::admin::role',
              response.data.payload.role
            );
            // this.props.history.push('/admin')
            // window.location.reload();
            window.location = '#/admin';
          } else {
            this.setState({
              errMessage: response.data.message,
            });
          }
        })
        .catch(function (err) {
          console.log('err: ', err);
        });
    }
  }

  sendByEnter(event) {
    if (event.which == 13) {
      this.login();
    }
  }

  render() {
    return (
      <div className="login-content">
        <Slide top>
          <div className="login-card m-auto">
            <div className="salom-logo text-center">
              <IconAlif />
            </div>
            <div className="form-group">
              <input
                type="email"
                className="form-control form-control-input"
                value={this.state.email}
                onChange={this.handleEmailChange}
                onKeyUp={this.sendByEnter}
                name="email"
                placeholder="E-mail"
              />
            </div>
            <div className="form-group">
              <input
                type="password"
                className="form-control form-control-input"
                value={this.state.password}
                onChange={this.handlePasswordChange}
                onKeyUp={this.sendByEnter}
                name="password"
                placeholder="Пароль"
              />
            </div>
            <div className="form-group">
              <button
                className="btn btn-danger btn-action height"
                onClick={this.login}
              >
                Войти
              </button>
            </div>
            <div className="text-danger text-center">
              {this.state.errMessage}
            </div>
          </div>
        </Slide>
      </div>
    );
  }
}

export default Login;
